import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'

import * as image from './image'
import * as i18n from './i18n'

type Amount = {
  type: typeof api.SponsorshipType.AMOUNT
  icon: '⚡️'
  amount: number
}

type Audience = {
  type: typeof api.SponsorshipType.AUDIENCE
  icon: '👏'
  label: string
}

type Crush = {
  type: typeof api.SponsorshipType.CRUSH
  icon: '❤️'
  label: string
}

type DoubleDonations = {
  type: typeof api.SponsorshipType.DOUBLED_DONATIONS
  icon: '⚡️'
  label: string
}

type PrizeWinner = {
  type: typeof api.SponsorshipType.PRIZE_WINNER
  icon: '🏆'
  label: string
}

type Tag = Amount | Audience | Crush | DoubleDonations | PrizeWinner

export function tag(sponsorship: api.Sponsorship<string>): Tag | undefined {
  switch (sponsorship.type) {
    case api.SponsorshipType.AMOUNT: {
      return {
        type: sponsorship.type,
        icon: '⚡️',
        amount: sponsorship.amount,
      }
    }
    case api.SponsorshipType.AUDIENCE: {
      return {
        type: sponsorship.type,
        icon: '👏',
        label: t('Crowd favorite prize'),
      }
    }
    case api.SponsorshipType.CRUSH: {
      return {
        type: sponsorship.type,
        icon: '❤️',
        label: t('Heartthrob'),
      }
    }
    case api.SponsorshipType.DOUBLED_DONATIONS: {
      return {
        type: sponsorship.type,
        icon: '⚡️',
        label: t('Matched donations'),
      }
    }
    case api.SponsorshipType.PRIZE_WINNER: {
      return {
        type: sponsorship.type,
        icon: '🏆',
        label: t('Winner'),
      }
    }
  }
}

export function mode(sponsorship: api.Sponsorship<string>): string {
  switch (sponsorship.mode) {
    case api.SponsorshipMode.PARTICIPATES_IN: {
      return t('Participates in')
    }
    case api.SponsorshipMode.PRIZE_WINNER: {
      return t('Prize winner')
    }
    case api.SponsorshipMode.CRUSH: {
      return t('Crush')
    }
    case api.SponsorshipMode.COACHED_BY: {
      return t('Coached by')
    }
    case api.SponsorshipMode.BENEFIT_OF: {
      return t('In benefit of')
    }
    default: {
      return t('Supported by')
    }
  }
}

export function avatar(sponsorship: api.Sponsorship<string>, version: string): string | undefined {
  return image.getUrl(sponsorship.sponsor.image.versions, version)
}

export function description<EXTRA_FIELDS extends string = ''>(sponsorship: api.Sponsorship<EXTRA_FIELDS>): string {
  return i18n.get(sponsorship.description, 'en', '')
}
